import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { useNavigate, useLocation } from "react-router-dom";
import API from "../Service/Baseservice";
import "../ContactUs/Contact.css";
import Loading from "../../Loading/loading";


const EditContact = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [languageId, setLanguageId] = useState(
        location.state?.languageId || 1
    );
    const [contactList, setContactList] = useState({});
    const [title, setTitle] = useState("");
    const [heading, setHeading] = useState("");
    const [description, setDescription] = useState("");
    const [address, setAddress] = useState("");
    const [phone_number, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(true);



    // --------------------------------------------------
    // FETCH DATA BASED ON LANGUAGE
    // --------------------------------------------------
    const fetchContactData = () => {
        setLoading(true);
        API.post("contactus_list1/condition", {
            model: "contactus_list1",
            language_id: languageId,
        })
            .then((res) => {
                const list = res.data?.data?.data;
                if (Array.isArray(list) && list.length > 0) {
                    const data = list[0];
                    setContactList(data);

                    // load values into input fields
                    setTitle(data.title || "");
                    setHeading(data.heading || "");
                    setDescription((data.description || "").replace(/&nbsp;/g, " "));
                    setAddress(data.address || "");
                    setPhone(String(data.phone_number || ""));
                    setEmail(data.email || "");
                }
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false);
            });
    };


    useEffect(() => {

        fetchContactData();
    }, [languageId]);

    const [popup, setPopup] = useState({
        show: false,
        type: "",       // success | error
        title: "",
        message: ""
    });

    const [errors, setErrors] = useState({});


    const validateFields = () => {
        const newErrors = {};

        if (!title.trim()) newErrors.title = "Title is required";
        if (!heading.trim()) newErrors.heading = "Heading is required";
        if (!description.trim() || description === "<p><br></p>")
            newErrors.description = "Description is required";

        if (!address.trim()) newErrors.address = "Address is required";

        // PHONE VALIDATIONS
        if (!phone_number.trim()) {
            newErrors.phone_number = "Phone number is required";
        } else if (!/^[0-9]{10}$/.test(phone_number)) {
            newErrors.phone_number = "Phone number must be 10 digits";
        }

        // EMAIL VALIDATION
        if (!email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = "Enter a valid email address";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // return true if no errors
    };

    const cleanDescription = description.replace(/&nbsp;/g, " ");

    // --------------------------------------------------
    // SAVE / UPDATE CONTACT DETAILS
    // --------------------------------------------------
    const contactedit = async () => {
        if (!validateFields()) {
            // setPopup({
            //     show: true,
            //     type: "error",
            //     title: "Validation Failed",
            //     message: "Please check all required fields."
            // });
            return;
        }

        try {
            const res = await API.post("contactus_edit/update", {
                model: "contactus_edit",
                contactus_id: contactList.contactus_id,
                language_id: languageId,
                contact_id: contactList.contact_id,
                title,
                heading,
                description: cleanDescription,
                address,
                phone_number,
                email,
                active: 1,
                updatedBy: 1,
            });

            setPopup({
                show: true,
                type: "success",
                title: "Success",
                message: "Contact information updated successfully!"
            });

        } catch (err) {
            console.error(err);
            setPopup({
                show: true,
                type: "error",
                title: "Failed",
                message: "Contact update failed. Try again!"
            });
        }
    };



    return (
        <div className="newss-containeradd">
            <div className="service-header-bar">
                <h2 className="services-title1">Edit Contact Support</h2>
                <div className="button-group">

                    <div className="filter-block">
                        <label>Language</label>
                        <div className="input-container">
                            <select
                                value={languageId}
                                className="input-field"
                                onChange={(e) => setLanguageId(Number(e.target.value))}
                            >
                                <option value={1}>English</option>
                                <option value={2}>Français</option>
                            </select>
                        </div>
                    </div>
                    <button className="language-save-btn" onClick={contactedit}>
                        Save
                    </button>

                    <button
                        style={{ marginTop: "24px" }}
                        onClick={() => navigate("/contactus")}
                        className="cancel-btn "
                    >
                        Back
                    </button>

                </div>
            </div>
            {loading ? (
                <Loading />
            ) : (

                <div className="edit-social-container">
                    <div className="left-form">

                        {/* Title */}
                        <div className="form-group">
                            <label>
                                Title <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                maxLength={70}
                                placeholder="Enter your text here..."
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                            <div className="inline-info">
                                <small>{title.length}/70</small>
                                {errors.title && <span className="error-text">{errors.title}</span>}
                            </div>


                        </div>

                        {/* Heading */}
                        <div className="form-group">
                            <label>
                                Heading <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                maxLength={150}
                                placeholder="Enter your text here..."
                                value={heading}
                                onChange={(e) => setHeading(e.target.value)}
                            />
                            <div className="inline-info">
                                <small>{heading.length}/150</small>
                                {errors.heading && <span className="error-text">{errors.heading}</span>}
                            </div>
                        </div>

                        {/* Description */}
                        <div className="form-group">
                            <label>
                                Description <span className="required">*</span>
                            </label>
                            <ReactQuill
                                placeholder="Enter description"
                                className="description-editor"
                                maxLength={4000}
                                value={description}
                                onChange={setDescription}
                            />
                            <small>{description.length}/4000</small>
                            {errors.description && <p className="error-text">{errors.description}</p>}

                        </div>

                        {/* Address */}
                        <div className="form-group">
                            <label>
                                Address <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                maxLength={150}
                                placeholder="Enter your text here..."
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                            />
                            <div className="inline-info">
                                <small>{address.length}/150</small>
                                {errors.address && <span className="error-text">{errors.address}</span>}
                            </div>
                        </div>

                        {/* Phone */}
                        <div className="form-group">
                            <label>
                                Phone <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                placeholder="Enter phone number..."
                                value={phone_number}
                                maxLength={10}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/[^0-9]/g, ""); // allow only digits
                                    setPhone(val);
                                }}
                            />
                            <div className="inline-info">
                                <small>{phone_number.length}/10</small>
                                {errors.phone_number && <span className="error-text">{errors.phone_number}</span>}
                            </div>
                        </div>

                        {/* Email */}
                        <div className="form-group">
                            <label>
                                Email <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                maxLength={150}
                                placeholder="Enter email..."
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <div className="inline-info">
                                <small>{email.length}/150</small>
                                {errors.email && <span className="error-text">{errors.email}</span>}
                            </div>
                        </div>
                    </div>

                </div>
            )}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <button
                            className="btn ok-btn"
                            onClick={() => {
                                setPopup({ ...popup, show: false });

                                if (popup.type === "success") {
                                    navigate("/contactus");
                                }
                            }}
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>


    );
};

export default EditContact;
